import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {"defaultBreakpoint":"mobile","breakpoints":{"mobile":769,"tablet":1024,"desktop":1216,"widescreen":1408,"fullhd":Infinity}})
